const baseUrl = "https://jianghuankeji.top:7000"
// const baseUrl = "http://localhost:7000"
const resourceUrl = "https://jianghuankeji.top:7000"

export {
    baseUrl,
    resourceUrl
}